export const config =  {
    firebaseConfig: {
    apiKey: "AIzaSyCaTWB7aOqwgsOE0RKgqOsMeBI1oy0a3uY",
    authDomain: "esg-requests.firebaseapp.com",
    projectId: "esg-requests",
    storageBucket: "esg-requests.appspot.com",
    messagingSenderId: "797534026777",
    appId: "1:797534026777:web:0827c5546cd0e19dd9be88"
  }
};